module.exports = __webpack_public_path__ + "static/media/sprite-v4.ea86689d.svg";